import type { PeakHoursResponse } from '@restaurant/api-client';

type DayPart = PeakHoursResponse['dayParts'][number]['dayPart'];

/** Day-part enum → `t.reports.dayParts` key. One source of truth for both the
 *  overview and the sales-overview detail page. */
export const DAY_PART_KEY: Record<
  DayPart,
  'breakfast' | 'lunch' | 'afternoon' | 'dinner' | 'late'
> = {
  BREAKFAST: 'breakfast',
  LUNCH: 'lunch',
  AFTERNOON: 'afternoon',
  DINNER: 'dinner',
  LATE: 'late',
};
